<template>
  <div class="login-social">
   <button class="btn btn-lg btn-facebook" @click="doLogin('facebook')"><i class="fab fa-facebook" /></button>
   <!-- <button class="btn btn-lg btn-twitter" @click="doLogin('twitter')" disabled><i class="fab fa-twitter" /></button> -->
    <button class="btn btn-lg btn-google" @click="doLogin('google')"><i class="fab fa-google" /></button>
  </div>
</template>
<script>
import firebase from 'firebase'

export default {
  methods: {
    getAuthProvider(source) {
      switch (source) {
        case 'facebook':
          return new firebase.auth.FacebookAuthProvider()
        case 'twitter':
          alert('Solo login con Google implementado')
          return new firebase.auth.TwitterAuthProvider()
        case 'google':
          const _provider = new firebase.auth.GoogleAuthProvider()
          _provider.addScope('https://www.googleapis.com/auth/plus.login')
          return _provider
      }
    },
    doLogin(provider) {
      this.$store.commit('isLoading', true)
      const _provider = this.getAuthProvider(provider)
      firebase
        .auth()
        .signInWithRedirect(_provider)
        .catch(err => {
          this.$store.commit('setError', err.message)
        })
      //this.$emit('userAuth', this.getAuthProvider(provider))
    }
  }
}
</script>

<style lang="scss">
.login-social {
  display: flex;
  align-items: center;
  justify-content: space-around;

  .btn {
    color: white;
    flex: 1;
    font-size: 1rem;
    max-width: 220px;
    padding: 1rem;

    @media screen and (max-width: 340px) {
      padding: 0.62rem;
    }

    i {
      font-size: 24px;
    }

    &:nth-child(2) {
      margin: 0 1rem;
    }
    &-facebook {
      background-color: #3c5b97;
    }
    &-twitter {
      background-color: #54b9eb;
    }
    &-google {
      background-color: #d04d35;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/User/LoginSocial.vue